import { UserService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "auto-verification",
  components: {},
  props: [],
  data() {
    return {
      QuickVerificationCancellationModal: false
    };
  },
  computed: {
    ...mapGetters({
      isModalOpen: types.image.getters.IS_MODAL_OPEN,
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    IDCardStatus() {
      return this.userVerify?.id_card_status;
    },
    videoStatus() {
      return this.userVerify?.video_status;
    },

    isApprove() {
      return (
        this.IDCardStatus === "VERIFIED" && this.videoStatus === "VERIFIED"
      );
    },

    isPending() {
      return (
        this.IDCardStatus === "PROCESSING" || this.videoStatus === "PROCESSING"
      );
    },

    isReject() {
      return (
        this.IDCardStatus === "REJECTED" || this.videoStatus === "REJECTED"
      );
    },

    hasIdentity() {
      return (
        this.userVerify?.personal_information_status !== null &&
        this.userVerify?.email_verification_status !== null &&
        this.userVerify?.mobile_verification_status !== null &&
        this.userVerify?.home_phone_verification_status !== null
      );
    }
  },
  methods: {
    ...mapActions({
      setUserVerifyInfo: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO
    }),
    setVerificationMethodToManual() {
      UserService.autoVerificationCancellation()
        .then(() => {
          this.getUserInfoVerify();
        })
        .then(() => {
          this.closeQuickVerificationCancellationModal();
        });
    },
    getUserInfoVerify() {
      UserService.getVerifyInfo().then(res => {
        this.setUserVerifyInfo(res.data.data);
      });
    },
    closeQuickVerificationCancellationModal() {
      this.QuickVerificationCancellationModal = false;
    },
    openQuickVerificationCancellationModal() {
      this.QuickVerificationCancellationModal = true;
    },
    goToKycTypeSelection() {
      this.$router.push({ name: "typeSelection" });
    }
  }
};
